/** Screen recording: the clip cards, the top status ledger and the preview. */
export default {
  clipStarting: "Starting clip {number}…",
  clipRecording: "Recording clip {number} · {seconds}s",
  clipSaving: "Saving clip {number}…",
  clipFailed: "Clip {number} · {error}",
  recordingFailed: "Recording failed",
  clipSaved: "Clip {number} · Saved · {seconds}s",
  clipDuration: "Clip {number} · {seconds}s",
  clip: "Clip {number}",
  playClip: "Play clip {number}",
  removeClip: "Remove clip {number}",
  previewClip: "Preview clip {number}",
  closePreview: "Close recording preview",
  releaseToFinish: "Release Caps Lock to finish",
  savedAt: "Saved at {path}",

  playSaved: "Play saved recording",
  previewFailed: "Couldn’t preview this recording. {error}",
  loadingRecording: "Loading recording…",
  preparingUpload: "Preparing upload…",
  uploading: "Uploading {percent}%",
  previewUnavailable: "Preview unavailable: {error}",
  uploadUnavailable:
    "Video upload unavailable: {error}. The saved path and available previews will be sent.",

  statusStarting: "Starting screen recording…",
  statusSaving: "Saving screen recording…",
  statusRecording: "Recording {seconds}s · Release Caps Lock to finish",

  failedTitle: "Screen recording failed",
  failedBody: "Please try recording again.",
  tooManyClips:
    "A request can include up to {max} clips. Remove a clip before sending.",
  stillSaving:
    "The screen recording is still being saved. Please try sending again.",
} as const;
